import { render, staticRenderFns } from "./m-feedback-form.vue?vue&type=template&id=845bd688&scoped=true"
import script from "./m-feedback-form.vue?vue&type=script&lang=js"
export * from "./m-feedback-form.vue?vue&type=script&lang=js"
import style0 from "./m-feedback-form.vue?vue&type=style&index=0&id=845bd688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845bd688",
  null
  
)

export default component.exports